import {
    CustomerEnum,
    DetectedContext,
    DeviceEnum,
    MobileOsEnum
} from "../types/context-detection";
import { ISearchBoxProps, ZeroQueryContext } from "../types/searchbox";
import { initPersonalization } from "./personalization/store";

// Provides methods to detect user, shop and device data.

export function isWebShop(): boolean {
    return (
        typeof window !== "undefined" &&
        (document.documentElement.classList.contains("desktop") ||
            document.documentElement.classList.contains("tablet"))
    );
}

export function isMobileShop(): boolean {
    return (
        typeof window !== "undefined" && document.documentElement.classList.contains("mobileshop")
    );
}

export function isTouchDevice(): boolean {
    return typeof window !== "undefined" && document.documentElement.classList.contains("isTouch");
}

function deviceType(): DeviceEnum {
    if (typeof window !== "undefined") {
        if (document.documentElement.classList.contains("isPhone")) return DeviceEnum.Phone;
        if (document.documentElement.classList.contains("isEsApp")) return DeviceEnum.Phone;
        if (document.documentElement.classList.contains("desktop")) return DeviceEnum.Desktop;
        if (document.documentElement.classList.contains("kiosk")) return DeviceEnum.Kiosk;
        if (document.documentElement.classList.contains("tablet")) return DeviceEnum.Tablet;
    }
    return DeviceEnum.None;
}

export function mobileOsType(): MobileOsEnum {
    if (typeof window !== "undefined") {
        const classList = document.documentElement.classList;
        if (classList.contains("isAndroid")) return MobileOsEnum.Android;
        if (classList.contains("isIOS") || classList.contains("ios")) return MobileOsEnum.Ios;
    }
    return MobileOsEnum.None;
}

function getCustomerType(): CustomerEnum {
    // use Private as default value
    let customerType = CustomerEnum.Private;

    if (typeof window !== "undefined") {
        const cookieValue = document.cookie
            .split("; ")
            .find((row) => row.startsWith("CustomerType="))
            ?.split("=")[1];

        if (cookieValue === "Company") customerType = CustomerEnum.Company;
        else if (cookieValue === "Surgery") customerType = CustomerEnum.Surgery;
    }
    return customerType;
}

export function detectContext(): DetectedContext {
    const zeroQueryContext = getZeroQueryRequestContext();
    if (zeroQueryContext !== undefined) initPersonalization(zeroQueryContext);

    return {
        isWebShop: isWebShop(),
        isMobileShop: isMobileShop(),
        device: deviceType(),
        customerType: getCustomerType()
    };
}
export function getZeroQueryRequestContext(): ZeroQueryContext | undefined {
    for (const key of SEARCH_BOX_STATES_FOR_ZERO_QUERY) {
        const ctx = window[key] as ISearchBoxProps | undefined;

        if (ctx?.zeroQueryContext !== undefined && ctx?.zeroQueryContext !== null) {
            return ctx.zeroQueryContext;
        }
    }
    console.debug(
        "[SSW Zero Query] Exhausted all state keys. No zero query request context found."
    );
    return undefined;
}

const SEARCH_BOX_STATES_FOR_ZERO_QUERY: Array<keyof Window> = [
    "__PRELOADED_SEARCHBOX_WIDE_STATE__",
    "__PRELOADED_SEARCHBOX_FLYOUT_STATE__",
    "__PRELOADED_SEARCHBOX_GRID_STATE__",
    "__PRELOADED_SEARCHBOX_MEGAMENU_STATE__"
];
